module.exports = __webpack_public_path__ + "static/media/qr.4890961d.jpg";